import { urlPointsToPlottrCloud } from '../helpers/file'

import { PLOTTR_KNOWN_FILES, PRO_KNOWN_FILES } from '../constants/applicationState'
import { finishCheckingFileToLoad } from '../actions/applicationState'
import {
  trialIsActive,
  proLicenseIsActive,
  plottrLicenseIsActive,
  needsToCheckLicense,
} from '../helpers/license'
import {
  START_CREATING_CLOUD_FILE,
  FINISH_CREATING_CLOUD_FILE,
  START_UPLOADING_FILE_TO_CLOUD,
  FINISH_UPLOADING_FILE_TO_CLOUD,
  START_LOADING_FILE,
  FINISH_LOADING_FILE,
  ERROR_LOADING_FILE,
  START_RENAMING_FILE,
  FINISH_RENAMING_FILE,
  START_LOGGING_IN,
  FINISH_LOGGING_IN,
  START_LOADING_A_LICENSE_TYPE,
  FINISH_LOADING_A_LICENSE_TYPE,
  START_LOADING_A_SETTINGS_TYPE,
  FINISH_LOADING_A_SETTINGS_TYPE,
  START_CHECKING_SESSION,
  FINISH_CHECKING_SESSION,
  START_LOADING_FILE_LIST,
  FINISH_LOADING_FILE_LIST,
  START_DELETING_FILE,
  FINISH_DELETING_FILE,
  START_CHECKING_FILE_TO_LOAD,
  FINISH_CHECKING_FILE_TO_LOAD,
  ADVANCE_PRO_ONBOARDING,
  START_ONBOARDING,
  FINISH_ONBOARDING,
  CANCEL_ONBOARDING,
  FINISH_PRO_ONBOARDING_HAVING_CHOSEN_PRO,
  START_SAVING_FILE_AS,
  FINISH_SAVING_FILE_AS,
  START_ONBOARDING_FROM_ROOT,
  START_IMPORTING_SCRIVENER,
  FINISH_IMPORTING_SCRIVENER,
  PROMPT_TO_UPLOAD_FILE,
  DISMISS_PROMPT_TO_UPLOAD_FILE,
  REQUEST_CHECK_FOR_UPDATE,
  PROCESS_RESPONSE_TO_REQUEST_UPDATE,
  DISMISS_UPDATE_NOTIFIER,
  SET_UPDATE_DOWNLOAD_PROGRESS,
  AUTO_CHECK_FOR_UPDATES,
  BUSY_WITH_WORK_THAT_PREVENTS_QUITTING,
  DONE_WITH_WORK_THAT_PREVENTS_QUITTING,
  CLEAR_ERROR_LOADING_FILE,
  INCREMENT_JUMP_COUNTER,
  START_SETTINGS_WIZARD,
  ADVANCE_SETTINGS_WIZARD,
  REGRESS_SETTINGS_WIZARD,
  FINISH_SETTINGS_WIZARD,
  START_EDITING,
  START_VIEWING,
  UNDO,
  REDO,
  START_SEARCHING,
  OPEN_SEARCH,
  OPEN_REPLACE,
  STAGE_LANGUAGE,
  SET_PATH_TO_PROJECT,
  OPEN_DASHBOARD_TO,
  DASHBOARD_CLOSED,
  FINISH_FIRST_TIME_BOOTING,
  START_FETCHING_A_LICENSE_TYPE,
  FINISH_FETCHING_A_LICENSE_TYPE,
  NO_FILE_TO_SHOW,
  START_FILE_IMPORT,
  FINISH_FILE_IMPORT,
  START_QUITTING,
  RECORD_FILE_URL_BOOTED_WITH,
  RECEIVED_WINDOW_STATE,
  SET_ONLINE,
  REGISTER_LOGGED_IN,
  REGISTER_LOGGED_OUT,
  SET_APP_SETTINGS,
  SET_TRIAL_INFO,
  SET_PLOTTR_LICENSE_INFO,
  SET_PRO_LICENSE_INFO,
  ASK_TO_RECONNECT,
  ASK_TO_LOGIN,
  ADVANCE_BOOTING_DISPLAY_STATE,
  DIFFICULTY_CONTACTING_LICENSING_API,
  SET_FORCE_LICENSE_CHECK,
  SET_PRE_PRODUCTION,
} from '../constants/ActionTypes'
import { EDITING, VIEWING, SEARCHING } from '../constants/editStates'

/**
 * @typedef {import('../index').ApplicationState} ApplicationState
 * @typedef {import('../index').MainApplicationStateToShow} MainApplicationStateToShow
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_LOADING = [
  RECORD_FILE_URL_BOOTED_WITH,
  FINISH_LOADING_A_SETTINGS_TYPE,
  FINISH_LOADING_FILE,
  FINISH_LOADING_A_LICENSE_TYPE,
  FINISH_LOADING_A_SETTINGS_TYPE,
  FINISH_CHECKING_SESSION,
  FINISH_CHECKING_FILE_TO_LOAD,
  FINISH_FETCHING_A_LICENSE_TYPE,
  RECEIVED_WINDOW_STATE,
  SET_PLOTTR_LICENSE_INFO,
  SET_PRO_LICENSE_INFO,
  SET_TRIAL_INFO,
  SET_ONLINE,
  REGISTER_LOGGED_IN,
  REGISTER_LOGGED_OUT,
  SET_APP_SETTINGS,
  ERROR_LOADING_FILE,
  ASK_TO_RECONNECT,
  DIFFICULTY_CONTACTING_LICENSING_API,
  PROMPT_TO_UPLOAD_FILE,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_PRO_ONBOARDING = [
  CANCEL_ONBOARDING,
  FINISH_PRO_ONBOARDING_HAVING_CHOSEN_PRO,
  SET_APP_SETTINGS,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_CHOICE = [SET_APP_SETTINGS, START_ONBOARDING_FROM_ROOT]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_TRIAL_EXPIRED = [SET_APP_SETTINGS, START_ONBOARDING_FROM_ROOT]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_PLEASE_CONNECT_TO_THE_INTERNET = [
  SET_ONLINE,
  SET_PLOTTR_LICENSE_INFO,
  SET_PLOTTR_LICENSE_INFO,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_PLOTTR_LICENSE_EXPIRED = [
  START_ONBOARDING_FROM_ROOT,
  START_ONBOARDING,
  REGISTER_LOGGED_OUT,
  SET_PLOTTR_LICENSE_INFO,
  SET_PRO_LICENSE_INFO,
  SET_APP_SETTINGS,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_PRO_LICENSE_EXPIRED = [
  START_ONBOARDING_FROM_ROOT,
  START_ONBOARDING,
  REGISTER_LOGGED_OUT,
  SET_PLOTTR_LICENSE_INFO,
  SET_PRO_LICENSE_INFO,
  SET_APP_SETTINGS,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_LOGIN = [
  START_ONBOARDING_FROM_ROOT,
  REGISTER_LOGGED_IN,
  SET_PLOTTR_LICENSE_INFO,
  SET_PRO_LICENSE_INFO,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_UPlOAD_LAST_OPENED_FILE_TO_PRO = [
  FINISH_UPLOADING_FILE_TO_CLOUD,
  DISMISS_PROMPT_TO_UPLOAD_FILE,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_ERROR_LOADING_FILE = [
  OPEN_DASHBOARD_TO,
  CLEAR_ERROR_LOADING_FILE,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_SETTINGS_WIZARD = [FINISH_SETTINGS_WIZARD]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_OFFLINE_SPLASH_SCREEN = [SET_ONLINE, SET_APP_SETTINGS]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_DASHBOARD = [
  SET_ONLINE,
  REGISTER_LOGGED_OUT,
  SET_PLOTTR_LICENSE_INFO,
  SET_PRO_LICENSE_INFO,
  SET_TRIAL_INFO,
  START_ONBOARDING,
  START_ONBOARDING_FROM_ROOT,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_APP = [
  SET_ONLINE,
  REGISTER_LOGGED_OUT,
  SET_PLOTTR_LICENSE_INFO,
  SET_PRO_LICENSE_INFO,
  SET_TRIAL_INFO,
]
/**
 * @type {Array<String>}
 */
const ACTIONS_THAT_MIGHT_ADVANCE_FROM_PRO_FILE_FROM_PLOTTR = [
  SET_PRO_LICENSE_INFO,
  SET_APP_SETTINGS,
]

/**
 * @param {PltrAction} action
 * @param {MainApplicationStateToShow} previousDisplayState
 * @param {ApplicationState} postActionApplicationState
 * @return {ApplicationState}
 */
const handleLoading = (action, previousDisplayState, postActionApplicationState) => {
  if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_LOADING.includes(action.type)) {
    const errorLoadingFile = postActionApplicationState.file.errorLoadingFile
    if (action.type === PROMPT_TO_UPLOAD_FILE) {
      return {
        ...postActionApplicationState,
        displayState: 'UPlOAD_LAST_OPENED_FILE_TO_PRO',
      }
    } else if (action.type === ASK_TO_LOGIN) {
      return {
        ...postActionApplicationState,
        displayState: 'LOGIN',
      }
    } else if (
      action.type === ASK_TO_RECONNECT ||
      action.type === DIFFICULTY_CONTACTING_LICENSING_API
    ) {
      return {
        ...postActionApplicationState,
        displayState: 'PLEASE_CONNECT_TO_THE_INTERNET',
      }
    } else if (errorLoadingFile) {
      return {
        ...postActionApplicationState,
        displayState: 'ERROR_LOADING_FILE',
      }
    } else {
      const settingsLoaded = postActionApplicationState.settings.settingsLoaded
      const fetchedState = postActionApplicationState.booting.receivedWindowState
      const finishedLoadingSettingsAndInstructionsFromMain = settingsLoaded && fetchedState
      const shouldLoadFile = !!postActionApplicationState.file.fileURLToBoot
      const fileLoaded = postActionApplicationState.file.fileLoaded
      const fileLoadedIfNeedsBe = (shouldLoadFile && fileLoaded) || !shouldLoadFile
      const fileToLoadIsProFile =
        postActionApplicationState.file.fileURLToBoot &&
        urlPointsToPlottrCloud(postActionApplicationState.file.fileURLToBoot)
      // Were we started with a file to load or should we display
      // the dashboard...
      //
      // TODO: account for the dashboard first setting!
      const appStateToDisplay = shouldLoadFile ? 'APP' : 'DASHBOARD'
      if (finishedLoadingSettingsAndInstructionsFromMain) {
        const shouldBeInPro = postActionApplicationState.featureSet.mode === 'PRO'
        const shouldBeInPlottr = postActionApplicationState.featureSet.mode === 'PLOTTR'
        const shouldBeInTrial = postActionApplicationState.featureSet.mode === 'TRIAL'
        if (shouldBeInPro) {
          const offlineModeEnabled = postActionApplicationState.featureSet.offlineModeEnabled
          const isOnline =
            postActionApplicationState.network.isOnline !== null &&
            postActionApplicationState.network.isOnline
          const loggedIn = postActionApplicationState.session.loggedIn
          if (!isOnline && !offlineModeEnabled) {
            return {
              ...postActionApplicationState,
              displayState: 'OFFLINE_SPLASH_SCREEN',
            }
          } else {
            const hasValidProLicense = postActionApplicationState.license.hasActiveProSubscription
            const needsToCheckProLicense =
              postActionApplicationState.license.needsToCheckProSubscription
            if (!hasValidProLicense) {
              if (needsToCheckProLicense) {
                // Too long has gone by since we last checked
                return {
                  ...postActionApplicationState,
                  displayState: 'PLEASE_CONNECT_TO_THE_INTERNET',
                }
              } else if (hasValidProLicense === false) {
                // The license has expired
                return {
                  ...postActionApplicationState,
                  displayState: 'PRO_LICENSE_EXPIRED',
                }
              } else if (!loggedIn) {
                // It is null, we need to log in and fetch.
                return {
                  ...postActionApplicationState,
                  displayState: 'LOGIN',
                }
              } else if (['DASHBOARD', 'APP'].includes(postActionApplicationState.displayState)) {
                // The license disapeared whilst running the app.  Leave
                // things in that state.  The next license check will
                // resolve the problem.
                return {
                  ...postActionApplicationState,
                  displayState: postActionApplicationState.displayState,
                }
              } else {
                // We're still waiting for more information
                return {
                  ...postActionApplicationState,
                  displayState: 'LOADING',
                }
              }
            } else if (fileLoadedIfNeedsBe) {
              return {
                ...postActionApplicationState,
                displayState: appStateToDisplay,
              }
            } else if (!fileToLoadIsProFile && appStateToDisplay !== 'APP') {
              return {
                ...postActionApplicationState,
                file: {
                  ...postActionApplicationState.file,
                  filePathToUpload: postActionApplicationState.file.fileURLToBoot,
                },
                displayState: appStateToDisplay,
              }
            } else {
              return {
                ...postActionApplicationState,
                displayState: 'LOADING',
              }
            }
          }
        } else if (shouldBeInPlottr) {
          const hasValidPlottrLicense =
            postActionApplicationState.license.hasActivePlottrSubscription
          const needsToCheckPlottrLicense =
            postActionApplicationState.license.needsToCheckPlottrSubscription
          const loggedIn = postActionApplicationState.session.loggedIn
          if (!hasValidPlottrLicense) {
            if (needsToCheckPlottrLicense) {
              // Too long has gone by since we last checked
              return {
                ...postActionApplicationState,
                displayState: 'PLEASE_CONNECT_TO_THE_INTERNET',
              }
            } else if (hasValidPlottrLicense === false) {
              return {
                ...postActionApplicationState,
                displayState: 'PLOTTR_LICENSE_EXPIRED',
              }
            } else if (!loggedIn) {
              // Plottr license is null.  We need to log in and fetch
              // it.
              return {
                ...postActionApplicationState,
                displayState: 'LOGIN',
              }
            } else if (['DASHBOARD', 'APP'].includes(postActionApplicationState.displayState)) {
              // The license disapeared whilst running the app.  Leave
              // things in that state.  The next license check will
              // resolve the problem.
              return {
                ...postActionApplicationState,
                displayState: postActionApplicationState.displayState,
              }
            } else {
              // We're still waiting for more information
              return {
                ...postActionApplicationState,
                displayState: 'LOADING',
              }
            }
          } else if (fileLoadedIfNeedsBe) {
            return {
              ...postActionApplicationState,
              displayState: appStateToDisplay,
            }
          } else if (fileToLoadIsProFile) {
            return {
              ...postActionApplicationState,
              displayState: 'PRO_FILE_FROM_PLOTTR',
            }
          } else {
            return {
              ...postActionApplicationState,
              displayState: 'LOADING',
            }
          }
        } else if (shouldBeInTrial) {
          const hasValidTrial =
            postActionApplicationState.license.hasActiveTrial &&
            postActionApplicationState.license.hasActiveTrial !== null
          if (!hasValidTrial) {
            return {
              ...postActionApplicationState,
              displayState: 'TRIAL_EXPIRED',
            }
          } else if (fileLoadedIfNeedsBe) {
            return {
              ...postActionApplicationState,
              displayState: appStateToDisplay,
            }
          } else if (fileToLoadIsProFile) {
            return {
              ...postActionApplicationState,
              displayState: 'PRO_FILE_FROM_PLOTTR',
            }
          } else {
            return {
              ...postActionApplicationState,
              displayState: appStateToDisplay,
            }
          }
        } else {
          // The user hasn't made a choice yet.  Show them the choice
          // screen.
          return {
            ...postActionApplicationState,
            displayState: 'CHOICE',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: 'LOADING',
        }
      }
    }
  } else {
    return {
      ...postActionApplicationState,
      displayState: previousDisplayState,
    }
  }
}

/**
 * Update the displayState based on what we were showing, the action
 * we just processed and the state after applying the action.
 *
 * @param {PltrAction} action
 * @param {MainApplicationStateToShow} previousDisplayState
 * @param {ApplicationState} postActionApplicationState
 * @param {ApplicationState} previousApplicationState
 * @return {ApplicationState}
 */
const advanceDisplayState = (
  action,
  previousDisplayState,
  postActionApplicationState,
  previousApplicationState
) => {
  switch (previousDisplayState) {
    case 'LOADING': {
      return handleLoading(action, previousDisplayState, postActionApplicationState)
    }
    case 'PRO_ONBOARDING': {
      const choseAMode =
        postActionApplicationState.featureSet.mode !== previousApplicationState.featureSet.mode &&
        postActionApplicationState.featureSet.mode !== null
      // NOTE(ed): we should only trigger this state change for action
      // types of SET_APP_SETTING if the change in app setting
      // resulted from the user picking a mode.
      if (
        ACTIONS_THAT_MIGHT_ADVANCE_FROM_PRO_ONBOARDING.includes(action.type) &&
        !(action.type === SET_APP_SETTINGS && !choseAMode)
      ) {
        const isOnboarding =
          postActionApplicationState.proOnboarding.isOnboardingFromRoot ||
          postActionApplicationState.proOnboarding.isOnboarding
        if (isOnboarding) {
          return {
            ...postActionApplicationState,
            displayState: 'PRO_ONBOARDING',
          }
        } else if (!choseAMode) {
          return {
            ...postActionApplicationState,
            displayState: 'CHOICE',
          }
        } else if (action.type === CANCEL_ONBOARDING) {
          const shouldLoadFile = !!postActionApplicationState.file.fileURLToBoot
          const appStateToDisplay = shouldLoadFile ? 'APP' : 'DASHBOARD'
          return {
            ...postActionApplicationState,
            displayState: appStateToDisplay,
          }
        } else {
          // The settings wizard is always the next step after
          // onboarding.
          return {
            ...postActionApplicationState,
            displayState: 'SETTINGS_WIZARD',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'CHOICE': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_CHOICE.includes(action.type)) {
        const isOnboarding =
          postActionApplicationState.proOnboarding.isOnboardingFromRoot ||
          postActionApplicationState.proOnboarding.isOnboarding
        const choseAMode = postActionApplicationState.featureSet.mode !== null
        if (isOnboarding) {
          return {
            ...postActionApplicationState,
            displayState: 'PRO_ONBOARDING',
          }
        } else if (choseAMode) {
          return {
            ...postActionApplicationState,
            displayState: 'DASHBOARD',
          }
        } else {
          return {
            ...postActionApplicationState,
            displayState: 'CHOICE',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'TRIAL_EXPIRED': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_TRIAL_EXPIRED.includes(action.type)) {
        const noModeSelected = postActionApplicationState.featureSet.mode === null
        const hasValidTrial =
          postActionApplicationState.license.hasActiveTrial &&
          postActionApplicationState.license.hasActiveTrial !== null
        if (noModeSelected) {
          return {
            ...postActionApplicationState,
            displayState: 'PRO_ONBOARDING',
          }
        } else if (!hasValidTrial) {
          return {
            ...postActionApplicationState,
            displayState: 'TRIAL_EXPIRED',
          }
        } else {
          return {
            ...postActionApplicationState,
            displayState: previousDisplayState,
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'PLEASE_CONNECT_TO_THE_INTERNET': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_PLEASE_CONNECT_TO_THE_INTERNET.includes(action.type)) {
        const isOnline =
          postActionApplicationState.network.isOnline !== null &&
          postActionApplicationState.network.isOnline
        if (isOnline) {
          return handleLoading(action, previousDisplayState, postActionApplicationState)
        } else {
          return {
            ...postActionApplicationState,
            displayState: 'PLEASE_CONNECT_TO_THE_INTERNET',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'PLOTTR_LICENSE_EXPIRED': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_PLOTTR_LICENSE_EXPIRED.includes(action.type)) {
        const isOnboarding =
          postActionApplicationState.proOnboarding.isOnboardingFromRoot ||
          postActionApplicationState.proOnboarding.isOnboarding
        const shouldBeInPlottr = postActionApplicationState.featureSet.mode === 'PLOTTR'
        if (!shouldBeInPlottr) {
          return handleLoading(action, previousDisplayState, postActionApplicationState)
        } else if (isOnboarding) {
          return {
            ...postActionApplicationState,
            displayState: 'PRO_ONBOARDING',
          }
        } else {
          return {
            ...postActionApplicationState,
            displayState: 'PLOTTR_LICENSE_EXPIRED',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'PRO_LICENSE_EXPIRED': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_PRO_LICENSE_EXPIRED.includes(action.type)) {
        const isOnboarding =
          postActionApplicationState.proOnboarding.isOnboardingFromRoot ||
          postActionApplicationState.proOnboarding.isOnboarding
        const loggedIn = postActionApplicationState.session.loggedIn
        const shouldBeInPro = postActionApplicationState.featureSet.mode === 'PRO'
        if (!loggedIn) {
          return {
            ...postActionApplicationState,
            displayState: 'LOGIN',
          }
        } else if (!shouldBeInPro) {
          return handleLoading(action, previousDisplayState, postActionApplicationState)
        } else if (isOnboarding) {
          return {
            ...postActionApplicationState,
            displayState: 'PRO_ONBOARDING',
          }
        } else {
          return {
            ...postActionApplicationState,
            displayState: 'PRO_LICENSE_EXPIRED',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'LOGIN': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_LOGIN.includes(action.type)) {
        if (action.type === START_ONBOARDING_FROM_ROOT) {
          return {
            ...postActionApplicationState,
            displayState: 'CHOICE',
          }
        } else {
          return handleLoading(action, previousDisplayState, postActionApplicationState)
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'UPlOAD_LAST_OPENED_FILE_TO_PRO': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_UPlOAD_LAST_OPENED_FILE_TO_PRO.includes(action.type)) {
        // This is only valid as a way of testing that we *finished*
        // uploading if the only actions included in this handler are
        // those which imply that we were uploading something.
        const finishedUploadingFileToPro = postActionApplicationState.file.uploadingFileToCloud
        if (!postActionApplicationState.file.filePathToUpload) {
          return {
            ...postActionApplicationState,
            displayState: 'DASHBOARD',
          }
        } else if (finishedUploadingFileToPro) {
          return {
            ...postActionApplicationState,
            displayState: 'DASHBOARD',
          }
        } else {
          return {
            ...postActionApplicationState,
            displayState: 'UPlOAD_LAST_OPENED_FILE_TO_PRO',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'ERROR_LOADING_FILE': {
      // The only recovery from error displaying file is to display
      // backups on the dashboard.
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_ERROR_LOADING_FILE.includes(action.type)) {
        const errorLoadingFile = postActionApplicationState.file.errorLoadingFile
        const dashboardSectionToDisplay = postActionApplicationState.dashboard.openTo
        if (!errorLoadingFile && dashboardSectionToDisplay) {
          return {
            ...postActionApplicationState,
            displayState: 'DASHBOARD',
          }
        } else {
          return {
            ...postActionApplicationState,
            displayState: previousDisplayState,
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'SETTINGS_WIZARD': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_SETTINGS_WIZARD.includes(action.type)) {
        const notInSettingsWizard = !postActionApplicationState.settingsWizard.isInSettingsWizard
        if (notInSettingsWizard) {
          return {
            ...postActionApplicationState,
            displayState: 'DASHBOARD',
          }
        } else {
          return {
            ...postActionApplicationState,
            displayState: 'SETTINGS_WIZARD',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'OFFLINE_SPLASH_SCREEN': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_OFFLINE_SPLASH_SCREEN.includes(action.type)) {
        const offlineModeEnabled = postActionApplicationState.featureSet.offlineModeEnabled
        const isOnline =
          postActionApplicationState.network.isOnline !== null &&
          postActionApplicationState.network.isOnline
        if (isOnline || offlineModeEnabled) {
          return handleLoading(action, previousDisplayState, postActionApplicationState)
        } else {
          return {
            ...postActionApplicationState,
            displayState: 'OFFLINE_SPLASH_SCREEN',
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'DASHBOARD': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_DASHBOARD.includes(action.type)) {
        if (action.type === START_ONBOARDING || action.type === START_ONBOARDING_FROM_ROOT) {
          return {
            ...postActionApplicationState,
            displayState: 'PRO_ONBOARDING',
          }
        } else {
          return handleLoading(action, previousDisplayState, postActionApplicationState)
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'APP': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_APP.includes(action.type)) {
        return handleLoading(action, previousDisplayState, postActionApplicationState)
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    case 'PRO_FILE_FROM_PLOTTR': {
      if (ACTIONS_THAT_MIGHT_ADVANCE_FROM_PRO_FILE_FROM_PLOTTR.includes(action.type)) {
        const shouldBeInPro = postActionApplicationState.featureSet.mode === 'PRO'
        const hasValidProLicense = postActionApplicationState.license.hasActiveProSubscription
        const shouldLoadFile = !!postActionApplicationState.file.fileURLToBoot
        const appStateToDisplay = shouldLoadFile ? 'APP' : 'DASHBOARD'
        if (hasValidProLicense && shouldBeInPro) {
          return {
            ...postActionApplicationState,
            displayState: appStateToDisplay,
          }
        } else {
          return {
            ...postActionApplicationState,
            displayState: previousDisplayState,
          }
        }
      } else {
        return {
          ...postActionApplicationState,
          displayState: previousDisplayState,
        }
      }
    }
    default: {
      // Move to the error screen if we set the state to an invalid value.
      return {
        ...postActionApplicationState,
        displayState: 'ERROR_LOADING_FILE',
      }
    }
  }
}

/**
 * @type {ApplicationState}
 */
const INITIAL_STATE = {
  project: {
    loadingPlottrFileList: false,
    loadingProFileList: false,
    fileListLoaded: false,
    importingNewProject: false,
    isImportingAProject: false,
  },
  file: {
    fileURLToBoot: null,
    filePathToUpload: null,
    checkingFileToLoad: false,
    checkedFileToLoad: false,
    creatingCloudFile: false,
    uploadingFileToCloud: false,
    loadingFile: false,
    fileLoaded: false,
    renamingFile: false,
    deletingFile: false,
    savingFileAs: false,
    pathToProjectDuringBoot: null,
    noFileToShow: false,
    errorLoadingFile: false,
    errorIsUpdateError: false,
  },
  session: {
    loggingIn: false,
    checkingSession: false,
    sessionChecked: false,
    loggedIn: null,
  },
  license: {
    loadingTrial: false,
    trialLoaded: false,
    loadingLicense: false,
    licenseLoaded: false,
    fetchingLicense: false,
    fetchedLicense: false,
    checkingProSubscription: false,
    proSubscriptionChecked: false,
    fetchingProSubscription: false,
    fetchedProSubscription: false,
    hasActiveProSubscription: null,
    needsToCheckProSubscription: null,
    hasActivePlottrSubscription: null,
    needsToCheckPlottrSubscription: null,
    hasActiveTrial: null,
  },
  settings: {
    loadingSettings: false,
    settingsLoaded: false,
    loadingExportConfig: false,
    exportConfigLoaded: false,
  },
  proOnboarding: {
    isOnboarding: false,
    isOnboardingFromRoot: false,
    onboardingStep: null,
    forceLicenseCheck: false,
  },
  settingsWizard: {
    isInSettingsWizard: false,
    wizardStep: null,
    stagedLanguage: null,
  },
  update: {
    requestedCheck: false,
    shouldCheck: true,
    checking: false,
    available: false,
    percentDownloaded: 0,
    downloadInProgress: false,
    error: null,
    info: null,
    notifierHidden: true,
  },
  work: {
    busy: false,
  },
  userInteractions: {
    jumpCounter: 0,
    editState: EDITING,
  },
  dashboard: {
    openTo: null,
    closed: false,
  },
  booting: {
    firstTimeBooting: true,
    receivedWindowState: false,
    percentageBooted: 0,
    descriptionOfBootingPhase: 'Loading',
  },
  shutdown: {
    isQuitting: false,
  },
  displayState: 'LOADING',
  network: {
    isOnline: null,
  },
  featureSet: {
    mode: null,
    offlineModeEnabled: null,
  },
  isProduction: true,
}

const startLoadingLicenseType = (licenseState, licenseType) => {
  switch (licenseType) {
    case 'trial': {
      return {
        ...licenseState,
        loadingTrial: true,
      }
    }
    case 'plottrLicense': {
      return {
        ...licenseState,
        loadingLicense: true,
      }
    }
    case 'proSubscription': {
      return {
        ...licenseState,
        checkingProSubscription: true,
      }
    }
    default: {
      return licenseState
    }
  }
}

const finishLoadingLicenseType = (licenseState, licenseType) => {
  switch (licenseType) {
    case 'trial': {
      return {
        ...licenseState,
        loadingTrial: false,
        trialLoaded: true,
      }
    }
    case 'plottrLicense': {
      return {
        ...licenseState,
        loadingLicense: false,
        licenseLoaded: true,
      }
    }
    case 'proSubscription': {
      return {
        ...licenseState,
        checkingProSubscription: false,
        proSubscriptionChecked: true,
      }
    }
    default: {
      return licenseState
    }
  }
}

const startFetchingLicenseType = (licenseState, licenseType) => {
  switch (licenseType) {
    case 'trial': {
      return {
        ...licenseState,
        fetchingTrial: true,
      }
    }
    case 'plottrLicense': {
      return {
        ...licenseState,
        fetchingLicense: true,
      }
    }
    case 'proSubscription': {
      return {
        ...licenseState,
        fetchingProSubscription: true,
      }
    }
    default: {
      return licenseState
    }
  }
}

const finishFetchingLicenseType = (licenseState, licenseType) => {
  switch (licenseType) {
    case 'trial': {
      return {
        ...licenseState,
        fetchingTrial: false,
        trialFetched: true,
      }
    }
    case 'plottrLicense': {
      return {
        ...licenseState,
        fetchingLicense: false,
        fetchedLicense: true,
      }
    }
    case 'proSubscription': {
      return {
        ...licenseState,
        fetchingProSubscription: false,
        fetchedProSubscription: true,
      }
    }
    default: {
      return licenseState
    }
  }
}

const startLoadingSettingsType = (settingsState, settingsType) => {
  switch (settingsType) {
    case 'exportConfig': {
      return {
        ...settingsState,
        loadingExportConfig: true,
      }
    }
    case 'settings': {
      return {
        ...settingsState,
        loadingSettings: true,
      }
    }
    default: {
      return settingsState
    }
  }
}

const finishLoadingSettingsType = (settingsState, settingsType) => {
  switch (settingsType) {
    case 'exportConfig': {
      return {
        ...settingsState,
        loadingExportConfig: false,
        exportConfigLoaded: true,
      }
    }
    case 'settings': {
      return {
        ...settingsState,
        loadingSettings: false,
        settingsLoaded: true,
      }
    }
    default: {
      return settingsState
    }
  }
}

/**
 * @param {ApplicationState} state
 * @param {PltrAction} action
 * @return {ApplicationState}
 */
function _applicationStateReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case START_LOADING_FILE_LIST: {
      if (action.fileListType === PRO_KNOWN_FILES) {
        return {
          ...state,
          project: {
            ...state.project,
            loadingProFileList: true,
          },
        }
      } else if (action.fileListType === PLOTTR_KNOWN_FILES) {
        return {
          ...state,
          project: {
            ...state.project,
            loadingPlottrFileList: true,
          },
        }
      } else {
        return state
      }
    }
    case FINISH_LOADING_FILE_LIST: {
      if (action.fileListType === PRO_KNOWN_FILES) {
        return {
          ...state,
          project: {
            ...state.project,
            fileListLoaded: true,
            loadingProFileList: false,
          },
        }
      } else if (action.fileListType === PLOTTR_KNOWN_FILES) {
        return {
          ...state,
          project: {
            ...state.project,
            fileListLoaded: true,
            loadingPlottrFileList: false,
          },
        }
      } else {
        return state
      }
    }
    case START_CREATING_CLOUD_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          creatingCloudFile: true,
        },
      }
    }
    case FINISH_CREATING_CLOUD_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          creatingCloudFile: false,
        },
      }
    }
    case START_UPLOADING_FILE_TO_CLOUD: {
      return {
        ...state,
        file: {
          ...state.file,
          uploadingFileToCloud: true,
        },
      }
    }
    case FINISH_UPLOADING_FILE_TO_CLOUD: {
      return {
        ...state,
        file: {
          ...state.file,
          uploadingFileToCloud: false,
        },
      }
    }
    case START_CHECKING_FILE_TO_LOAD: {
      return {
        ...state,
        file: {
          ...state.file,
          checkingFileToLoad: true,
        },
      }
    }
    case FINISH_CHECKING_FILE_TO_LOAD: {
      return {
        ...state,
        file: {
          ...state.file,
          checkingFileToLoad: false,
          checkedFileToLoad: true,
        },
      }
    }
    case PROMPT_TO_UPLOAD_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          filePathToUpload: action.filePath,
        },
      }
    }
    case DISMISS_PROMPT_TO_UPLOAD_FILE: {
      return applicationStateReducer(
        {
          ...state,
          file: {
            ...state.file,
            filePathToUpload: null,
          },
        },
        finishCheckingFileToLoad()
      )
    }
    case START_LOADING_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          loadingFile: true,
          fileLoaded: false,
        },
      }
    }
    case FINISH_LOADING_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          loadingFile: false,
          fileLoaded: true,
        },
      }
    }
    case ERROR_LOADING_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          errorLoadingFile: true,
          errorIsUpdateError: action.errorIsUpdateError,
          loadingFile: true,
          fileLoaded: false,
        },
      }
    }
    case CLEAR_ERROR_LOADING_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          errorLoadingFile: false,
          loadingFile: false,
          fileLoaded: false,
        },
      }
    }
    case START_RENAMING_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          renamingFile: true,
        },
      }
    }
    case FINISH_RENAMING_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          renamingFile: false,
        },
      }
    }
    case START_DELETING_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          deletingFile: true,
        },
      }
    }
    case FINISH_DELETING_FILE: {
      return {
        ...state,
        file: {
          ...state.file,
          deletingFile: false,
        },
      }
    }
    case START_SAVING_FILE_AS: {
      return {
        ...state,
        file: {
          ...state.file,
          savingFileAs: true,
        },
      }
    }
    case FINISH_SAVING_FILE_AS: {
      return {
        ...state,
        file: {
          ...state.file,
          savingFileAs: false,
        },
      }
    }
    case START_LOGGING_IN: {
      return {
        ...state,
        session: {
          ...state.session,
          loggingIn: true,
        },
      }
    }
    case FINISH_LOGGING_IN: {
      return {
        ...state,
        session: {
          ...state.session,
          loggingIn: false,
        },
      }
    }
    case START_CHECKING_SESSION: {
      return {
        ...state,
        session: {
          ...state.session,
          checkingSession: true,
        },
      }
    }
    case FINISH_CHECKING_SESSION: {
      return {
        ...state,
        session: {
          ...state.session,
          checkingSession: false,
          sessionChecked: true,
        },
      }
    }
    case START_LOADING_A_LICENSE_TYPE: {
      return {
        ...state,
        license: {
          ...startLoadingLicenseType(state.license, action.licenseType),
        },
      }
    }
    case FINISH_LOADING_A_LICENSE_TYPE: {
      return {
        ...state,
        license: {
          ...finishLoadingLicenseType(state.license, action.licenseType),
        },
      }
    }
    case START_FETCHING_A_LICENSE_TYPE: {
      return {
        ...state,
        license: {
          ...startFetchingLicenseType(state.license, action.licenseType),
        },
      }
    }
    case FINISH_FETCHING_A_LICENSE_TYPE: {
      return {
        ...state,
        license: {
          ...finishFetchingLicenseType(state.license, action.licenseType),
        },
      }
    }
    case START_LOADING_A_SETTINGS_TYPE: {
      return {
        ...state,
        settings: {
          ...startLoadingSettingsType(state.settings, action.settingsType),
        },
      }
    }
    case FINISH_LOADING_A_SETTINGS_TYPE: {
      return {
        ...state,
        settings: {
          ...finishLoadingSettingsType(state.settings, action.settingsType),
        },
      }
    }
    case ADVANCE_SETTINGS_WIZARD: {
      if (!state.settingsWizard.isInSettingsWizard) {
        return state
      }
      const wizardStep = state.settingsWizard.wizardStep ? state.settingsWizard.wizardStep : 1
      return {
        ...state,
        settingsWizard: {
          ...state.settingsWizard,
          wizardStep: wizardStep + 1,
        },
      }
    }
    case REGRESS_SETTINGS_WIZARD: {
      if (!state.settingsWizard.isInSettingsWizard) {
        return state
      }
      const wizardStep = state.settingsWizard.wizardStep ? state.settingsWizard.wizardStep : 1
      const nextStep = wizardStep - 1
      return {
        ...state,
        settingsWizard: {
          ...state.settingsWizard,
          wizardStep: nextStep < 1 ? 1 : nextStep,
        },
      }
    }
    case START_SETTINGS_WIZARD: {
      if (state.settingsWizard.isInSettingsWizard) {
        return state
      }
      return {
        ...state,
        settingsWizard: {
          ...state.settingsWizard,
          isInSettingsWizard: true,
          wizardStep: 1,
        },
      }
    }
    case FINISH_SETTINGS_WIZARD: {
      if (!state.settingsWizard.isInSettingsWizard) {
        return state
      }
      return {
        ...state,
        settingsWizard: {
          ...state.settingsWizard,
          isInSettingsWizard: false,
          wizardStep: 1,
        },
      }
    }
    case STAGE_LANGUAGE: {
      if (!state.settingsWizard.isInSettingsWizard) {
        return state
      } else {
        return {
          ...state,
          settingsWizard: {
            ...state.settingsWizard,
            stagedLanguage: action.language,
          },
        }
      }
    }
    case SET_PATH_TO_PROJECT: {
      return {
        ...state,
        file: {
          ...state.file,
          pathToProjectDuringBoot: action.filePath,
        },
      }
    }
    case NO_FILE_TO_SHOW: {
      return {
        ...state,
        file: {
          ...state.file,
          noFileToShow: true,
        },
      }
    }
    case OPEN_DASHBOARD_TO: {
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          openTo: action.view,
        },
      }
    }
    case DASHBOARD_CLOSED: {
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          closed: true,
        },
      }
    }
    case FINISH_FIRST_TIME_BOOTING: {
      return {
        ...state,
        booting: {
          ...state.booting,
          firstTimeBooting: false,
        },
      }
    }
    case ADVANCE_PRO_ONBOARDING: {
      if (!state.proOnboarding.isOnboarding && !state.proOnboarding.isOnboardingFromRoot) {
        return state
      }
      const onboardingStep = state.proOnboarding.onboardingStep
        ? state.proOnboarding.onboardingStep
        : 0
      return {
        ...state,
        proOnboarding: {
          ...state.proOnboarding,
          onboardingStep: onboardingStep + 1,
        },
      }
    }
    case START_ONBOARDING: {
      if (state.proOnboarding.isOnboarding || state.proOnboarding.isOnboardingFromRoot) {
        return state
      }
      return {
        ...state,
        proOnboarding: {
          ...state.proOnboarding,
          isOnboarding: true,
          onboardingStep: 0,
        },
        license: {
          ...state.license,
          fetchingProSubscription: false,
          fetchedProSubscription: false,
          fetchingLicense: false,
          fetchedLicense: false,
        },
        session: {
          ...state.session,
          loggingIn: false,
        },
      }
    }
    case START_ONBOARDING_FROM_ROOT: {
      if (state.proOnboarding.isOnboardingFromRoot || state.proOnboarding.isOnboardingFromRoot) {
        return state
      }
      return {
        ...state,
        proOnboarding: {
          ...state.proOnboarding,
          isOnboardingFromRoot: true,
          onboardingStep: 0,
        },
        license: {
          ...state.license,
          fetchingProSubscription: false,
          fetchedProSubscription: false,
          fetchingLicense: false,
          fetchedLicense: false,
        },
        featureSet: {
          ...state.featureSet,
          mode: null,
        },
      }
    }
    case CANCEL_ONBOARDING:
    case FINISH_ONBOARDING: {
      if (!state.proOnboarding.isOnboarding && !state.proOnboarding.isOnboardingFromRoot) {
        return state
      }
      return {
        ...state,
        proOnboarding: {
          ...state.proOnboarding,
          isOnboarding: false,
          isOnboardingFromRoot: false,
        },
      }
    }
    case SET_FORCE_LICENSE_CHECK: {
      return {
        ...state,
        proOnboarding: {
          ...state.proOnboarding,
          forceLicenseCheck: action.forceLicenseCheck,
        },
      }
    }

    case START_FILE_IMPORT:
    case START_IMPORTING_SCRIVENER: {
      return {
        ...state,
        project: {
          ...state.project,
          isImportingAProject: true,
        },
      }
    }

    case FINISH_FILE_IMPORT:
    case FINISH_IMPORTING_SCRIVENER: {
      return {
        ...state,
        project: {
          ...state.project,
          isImportingAProject: false,
        },
      }
    }
    case REQUEST_CHECK_FOR_UPDATE: {
      return {
        ...state,
        update: {
          ...state.update,
          requestedCheck: true,
          checking: true,
          shouldCheck: false,
          notifierHidden: false,
        },
      }
    }
    case AUTO_CHECK_FOR_UPDATES: {
      return {
        ...state,
        update: {
          ...state.update,
          checking: true,
          shouldCheck: false,
          notifierHidden: false,
        },
      }
    }
    case PROCESS_RESPONSE_TO_REQUEST_UPDATE: {
      const { available, error, info } = action

      return {
        ...state,
        update: {
          ...state.update,
          checking: false,
          available,
          error,
          info,
        },
      }
    }
    case DISMISS_UPDATE_NOTIFIER: {
      return {
        ...state,
        update: {
          ...state.update,
          notifierHidden: true,
          error: null,
          info: null,
        },
      }
    }
    case SET_UPDATE_DOWNLOAD_PROGRESS: {
      const { percent } = action
      if (percent === state.update.percentDownloaded) {
        return state
      }

      return {
        ...state,
        update: {
          ...state.update,
          percentDownloaded: percent,
          downloadInProgress: percent < 100,
        },
      }
    }
    case BUSY_WITH_WORK_THAT_PREVENTS_QUITTING: {
      return {
        ...state,
        work: {
          busy: true,
        },
      }
    }
    case DONE_WITH_WORK_THAT_PREVENTS_QUITTING: {
      return {
        ...state,
        work: {
          busy: false,
        },
      }
    }
    case INCREMENT_JUMP_COUNTER: {
      return {
        ...state,
        userInteractions: {
          ...state.userInteractions,
          jumpCounter: (state.userInteractions.jumpCounter || 0) + 1,
        },
      }
    }
    case START_EDITING: {
      return {
        ...state,
        userInteractions: {
          ...state.userInteractions,
          editState: EDITING,
        },
      }
    }
    case START_VIEWING: {
      return {
        ...state,
        userInteractions: {
          ...state.userInteractions,
          editState: VIEWING,
        },
      }
    }
    case UNDO:
    case REDO: {
      return {
        ...state,
        userInteractions: {
          ...state.userInteractions,
          editState: VIEWING,
        },
      }
    }
    case OPEN_REPLACE:
    case OPEN_SEARCH:
    case START_SEARCHING: {
      return {
        ...state,
        userInteractions: {
          ...state.userInteractions,
          editState: SEARCHING,
        },
      }
    }
    case START_QUITTING: {
      return {
        ...state,
        shutdown: {
          isQuitting: true,
        },
      }
    }
    case RECORD_FILE_URL_BOOTED_WITH: {
      return {
        ...state,
        file: {
          ...state.file,
          fileURLToBoot: action.fileURL,
        },
      }
    }
    case RECEIVED_WINDOW_STATE: {
      return {
        ...state,
        booting: {
          ...state.booting,
          receivedWindowState: true,
        },
      }
    }
    case SET_ONLINE: {
      return {
        ...state,
        network: {
          ...state.network,
          isOnline: action.isOnline,
        },
      }
    }
    case REGISTER_LOGGED_IN: {
      return {
        ...state,
        session: {
          ...state.session,
          loggedIn: true,
        },
      }
    }
    case REGISTER_LOGGED_OUT: {
      return {
        ...state,
        session: {
          ...state.session,
          loggedIn: false,
        },
      }
    }
    case SET_APP_SETTINGS: {
      return {
        ...state,
        featureSet: {
          ...state.featureSet,
          mode: action.appSettings.user.choseProMode
            ? 'PRO'
            : action.appSettings.user.chosePlottrMode
              ? 'PLOTTR'
              : action.appSettings.user.choseTrialMode
                ? 'TRIAL'
                : null,
          offlineModeEnabled: !!action.appSettings.user.enableOfflineModeV2,
        },
      }
    }
    case SET_TRIAL_INFO: {
      return {
        ...state,
        license: {
          ...state.license,
          hasActiveTrial:
            action.trialInfo === null
              ? null
              : trialIsActive(action.trialInfo.startsAt, action.trialInfo.endsAt, action.now),
        },
      }
    }
    case SET_PRO_LICENSE_INFO: {
      return {
        ...state,
        license: {
          ...state.license,
          hasActiveProSubscription: action.licenseInfo
            ? proLicenseIsActive(
                action.licenseInfo.dateChecked,
                action.licenseInfo.expiresAt,
                action.now,
                state.isProduction
              )
            : null,
          needsToCheckProSubscription: action.licenseInfo
            ? needsToCheckLicense(
                action.licenseInfo.dateChecked,
                action.licenseInfo.expiresAt,
                action.now,
                state.isProduction
              )
            : null,
        },
      }
    }
    case SET_PLOTTR_LICENSE_INFO: {
      return {
        ...state,
        license: {
          ...state.license,
          hasActivePlottrSubscription: action.licenseInfo
            ? plottrLicenseIsActive(
                action.licenseInfo.dateChecked,
                action.licenseInfo.expiresAt,
                action.now,
                state.isProduction
              )
            : null,
          needsToCheckPlottrSubscription: action.licenseInfo
            ? needsToCheckLicense(
                action.licenseInfo.dateChecked,
                action.licenseInfo.expiresAt,
                action.now,
                state.isProduction
              )
            : null,
        },
      }
    }
    case ADVANCE_BOOTING_DISPLAY_STATE: {
      return {
        ...state,
        booting: {
          ...state.booting,
          descriptionOfBootingPhase: action.description,
          percentageBooted: action.percentageCompleted,
        },
      }
    }
    case SET_PRE_PRODUCTION: {
      return {
        ...state,
        isProduction: false,
      }
    }
    default: {
      return state
    }
  }
}

/**
 * @param {ApplicationState} state
 * @param {PltrAction} action
 * @return {ApplicationState}
 */
const applicationStateReducer = (state = INITIAL_STATE, action) => {
  const previousDisplayState = state.displayState
  const newState = _applicationStateReducer(state, action)
  return advanceDisplayState(action, previousDisplayState, newState, state)
}

export default applicationStateReducer
